<template>
    <div>
        <new-atout-popup
            :data-to-show="isNewAtoutPopupDisplayed"
            @close="changeStateNewAtoutPopup(false)"
            @addAtout="(newValue) => {addNewAtout(newValue)}"
            :limit="hasLimit ? 22 : null"
        />

        <h3 class="my-15">Valeurs personnelles</h3>

        <div class="mx-10 text-xs mb-10 text-justify">
            <p>Les valeurs personnelles sont les convictions que nous considérons comme particulièrement importantes pour nous, celles qui constituent nos repères essentiels et qui nous servent à effectuer nos choix les plus importants.</p>
        </div>

        <div class="mx-10">
            <div v-if="isErrorMaxLengthDisplayed" class="text-pink-600 text-base text-center mb-8">
                Le nombre de valeurs maximal a été atteint pour ce type de CV
            </div>
            <div v-if="isErrorMinLengthDisplayed" class="text-pink-600 text-base text-center mb-8">
                Afin d'avoir un rendu visuel optimal, il faut sélectionner entre 3 et 5 valeurs
            </div>
            <div class="relative w-max">
                <add-button
                    class="mb-8"
                    libelle="Ajouter une nouvelle valeur"
                    @add="changeStateNewAtoutPopup(true)"
                />
            </div>

            <!-- BEGIN list atouts and updated atouts from CV datas -->
            <!-- BEGIN list default atout add by Neopass -->
            <div class="grid grid-cols-3 gap-3">
                <div
                    v-for="(dAtout, kda) in defaultAtouts"
                    :key="'default'+kda"
                    class="col-span-full md:col-span-1"
                >
                    <tag
                        @push="displayDefaultAtout(dAtout)"
                        class="cursor-pointer"
                        :theme-color="((((form.data.atouts || {}).value || {}).default || []).includes(dAtout)) ? 'indigo-2' : 'white'"
                        :libelle="dAtout"
                        text-size="text-sm"
                        text-font="font-light"
                        :icon="((((form.data.atouts || {}).value || {}).default || [])[kda] === dAtout) ? 'minus-circle' : 'plus-circle'"
                        :icon-color="((((form.data.atouts || {}).value || {}).default || [])[kda] === dAtout) ? 'text-indigo-600' : 'text-gray-600'"
                        icon-size="w-4 h-4"
                        :can-truncate="true"
                        :scale-on-hover="true"
                    />
                </div>
            </div>
            <!-- END list default atout add by Neopass -->
            <hr class="my-5" />
            <!-- BEGIN list perso atouts add by Particulier -->
            <div class="grid grid-cols-3 gap-3">
                <div
                    v-for="(pAtout, kpa) in persoAtouts"
                    :key="'perso'+kpa"
                    class="col-span-1"
                >
                    <tag
                        @push="displayPersoAtout(kpa)"
                        class="cursor-pointer"
                        :theme-color="pAtout.isDisplayed ? 'indigo-2' : 'white'"
                        :libelle="pAtout.value"
                        text-size="text-sm"
                        text-font="font-light"
                        :icon="pAtout.isDisplayed ? 'minus-circle' : 'plus-circle'"
                        :icon-color="pAtout.isDisplayed ? 'text-indigo-600' : 'text-gray-600'"
                        icon-size="w-4 h-4"
                        :can-truncate="true"
                        :scale-on-hover="true"
                    />
                </div>
            </div>
            <!-- END list perso atouts add by Particulier -->
            <!-- END list atouts and updated atouts from CV datas -->
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import ClickOutside from 'vue-click-outside';

import AddButton from './../../../components/Inputs/AddButton.vue';
import Icon from './../../../components/Icon.vue';
import Tag from './../../../components/Tag.vue';
import NewAtoutPopup from './../popup/NewAtoutPopup.vue';
import CVNewValue from './CVNewValue';

import ActionButton from './../../../components/ActionButton.vue';
import Illustration from './../../../components/Illustration.vue';

import Constants from './../../../constants';

export default {
  components:{
    AddButton,
    Icon,
    Tag,
    NewAtoutPopup,
    draggable,
    ActionButton,
    Illustration,
    CVNewValue,
  },

  data(){
    return{
      isNewAtoutPopupDisplayed: false,
      metierToDisplay: '',
      isRefresh: false,
      isErrorMaxLengthDisplayed: false,
      isErrorMinLengthDisplayed: false,
      constants: Constants,
    };
  },

  methods:{
    ...mapActions({
      'saveDatas': 'curriculumVitae/saveDatas',
    }),

    changeStateNewAtoutPopup(state){
      this.isNewAtoutPopupDisplayed = state;
    },

    addNewAtout(listAtout){
      let list = (typeof listAtout === 'string') ? listAtout.split(',').map(w => w.trim()) : listAtout;

      if((this.form.data.atouts || {}).value === undefined){
        this.form.data.atouts = {
          value: {
            default:[],
            perso: [],
          }
        };
      }

      list.forEach(atout => {
        this.form.data.atouts.value.perso.push(
          {
            fromNeopass: false,
            isDisplayed: (this.hasLimit && this.nbDisplayedAtouts >= 5) ? false : true,
            value:atout
          }
        );
      });
            
      this.$forceUpdate();
      this.saveDatas();
            
      this.isRefresh = true;
      setTimeout(() => { this.isRefresh = false; }, 2000);
    },

    displayDefaultAtout(val){
      if((this.form.data.atouts || {}).value === undefined){
        this.form.data.atouts = {
          value: {
            default:[],
            perso: [],
          }
        };
      }
            
      if(this.displayLengthErrorMessage(true, null, val)){
        return;
      }

      if(this.form.data.atouts.value.default.includes(val)){ // unselect value
        this.form.data.atouts.value.default = this.form.data.atouts.value.default.filter(v => v != val);
      }
      else{ // select value
        this.form.data.atouts.value.default.push(val);
      }
 
      this.$forceUpdate();
      this.saveDatas();
    },

    displayPersoAtout(index){
      if(this.displayLengthErrorMessage(false, index)){
        return;
      }

      this.form.data.atouts.value.perso[index].isDisplayed = !this.form.data.atouts.value.perso[index].isDisplayed;
            
      this.$forceUpdate();
      this.saveDatas();
    },

    displayLengthErrorMessage(isDefault, index = null, val = null){
      if(this.hasLimit){
        if( // There will has too much Atouts
          (!isDefault && !this.form.data.atouts.value.perso[index].isDisplayed 
                    || isDefault && !this.form.data.atouts.value.default.includes(val))
                    && this.nbDisplayedAtouts >= 5
        ){
          this.isErrorMaxLengthDisplayed = true;
          return true;
        }
        if( // There will has less than max limit
          (!isDefault && this.form.data.atouts.value.perso[index].isDisplayed 
                    || isDefault && this.form.data.atouts.value.default.includes(val))
                    && this.nbDisplayedAtouts === 5
        ){
          this.isErrorMaxLengthDisplayed = false;
          return false;
        }
        if( //There will has not enough Atouts
          (!isDefault && this.form.data.atouts.value.perso[index].isDisplayed 
                    || isDefault && this.form.data.atouts.value.default.includes(val))
                    && this.nbDisplayedAtouts <= 3
        ){
          this.isErrorMinLengthDisplayed = true;
          return false;
        }
        if( // There will has enough Atouts
          (!isDefault && !this.form.data.atouts.value.perso[index].isDisplayed 
                    || isDefault && !this.form.data.atouts.value.default.includes(val))
                    && this.nbDisplayedAtouts >= 2
        ){
          this.isErrorMinLengthDisplayed = false;
          return false;
        }
      }

      return false;
    }
  },

  computed:{
    ...mapGetters({
      'form' : 'curriculumVitae/form',
      'backdoor': 'app/backdoor',
    }),

    persoAtouts(){
      this.backdoor; //here value to reactivity
      return ((this.form.data.atouts.value || {}).perso || {});
    },

    defaultAtouts(){
      return Constants.cvdatas.atouts.sort();
    },

    dragOptions() {
      return {
        animation: 500,
      };
    },

    nbDisplayedAtouts(){
      this.backdoor; //for reactivity

      let nbDefaultValues = (this.form.data.atouts.value || {}).default === undefined ? 0 : this.form.data.atouts.value.default.filter(a => a && a != '').reduce((acc, atout) => acc + Math.ceil((atout.length)/22), 0);
      let nbPersoValues = (this.form.data.atouts.value || {}).perso === undefined ? 0 : this.form.data.atouts.value.perso.filter(a => a.isDisplayed).reduce((acc, atout) => acc + Math.ceil((atout.value.length)/22), 0);

      return nbDefaultValues + nbPersoValues;
    },
        
    hasLimit(){
      return [Constants.CV_TYPES.DASHBOARD].includes(this.form.type);
    }
  },

  watch:{
    form: {
      handler() {
        this.saveDatas();
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside
  }
};
</script>
